import React, { useState, useEffect } from 'react';
import { Modal, Toast, Form } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import TextareaAutosize from "react-textarea-autosize";

const AddAulaModal = ({
	showModalAddAula,
	setShowModalAddAula,
	setShowModalAddModulo,
	setIdCurso,
	idCurso: idCursoState,
	idModulo: idModuloProp,
	/** Quando já estamos na página do módulo (ex.: Aulas.js) — evita depender só de listar-modulos carregar */
	moduloAtual,
	file0Selected,
	setFile0Selected,
	file1Selected,
	setFile1Selected,
	file2Selected,
	setFile2Selected,
	uploadAulaProgress,
	register_A,
	control_A,
	errors_A,
	handleSubmit_A,
	onSubmitAddAula,
	setValue_A,
	clearErrors_A,
	setValue_M,
	customStyles,
	dataCursos,
	dataModulos
}) => {
	const [toast, setToast] = useState({});
	const [showToast, setShowToast] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [idCursoLocal, setIdCursoLocal] = useState(idCursoState || "");
	/** false = upload arquivos | true = URL externa (html_externo no backend) */
	const [urlExterna, setUrlExterna] = useState(false);

	useEffect(() => {
		if (!showModalAddAula) {
			setUrlExterna(false);
		}
	}, [showModalAddAula]);

	// Sincronizar idCurso local quando prop mudar
	useEffect(() => {
		if (idCursoState) {
			setIdCursoLocal(idCursoState);
		}
	}, [idCursoState]);

	// Pré-selecionar curso e módulo quando modal abrir com props
	useEffect(() => {
		if (showModalAddAula && dataCursos) {
			// Contexto direto da página do módulo (lista de módulos ainda pode estar vazia)
			if (
				idModuloProp &&
				moduloAtual &&
				parseInt(idModuloProp, 10) === moduloAtual.id &&
				moduloAtual.idCurso
			) {
				const curso = dataCursos.find(c => c.id === parseInt(moduloAtual.idCurso, 10));
				if (curso) {
					setIdCursoLocal(moduloAtual.idCurso);
					if (setIdCurso) {
						setIdCurso(moduloAtual.idCurso);
					}
					setValue_A("curso", { value: curso.id, label: curso.nome });
					setValue_A("modulo", { value: moduloAtual.id, label: moduloAtual.nome });
					return;
				}
			}
			if (showModalAddAula && dataModulos && idModuloProp && dataModulos.length > 0) {
				const modulo = dataModulos.find(m => m.id === parseInt(idModuloProp, 10));
				if (modulo && modulo.idCurso) {
					const cursoId = modulo.idCurso;
					const curso = dataCursos.find(c => c.id === parseInt(cursoId, 10));
					if (curso) {
						setIdCursoLocal(cursoId);
						if (setIdCurso) {
							setIdCurso(cursoId);
						}
						setValue_A("curso", { value: curso.id, label: curso.nome });
						setValue_A("modulo", { value: modulo.id, label: modulo.nome });
					}
				}
			} else if (idCursoState && dataCursos.length > 0) {
				// Se apenas idCurso fornecido, pré-selecionar curso
				const curso = dataCursos.find(c => c.id === parseInt(idCursoState));
				if (curso) {
					setIdCursoLocal(idCursoState);
					if (setIdCurso) {
						setIdCurso(idCursoState);
					}
					setValue_A("curso", { value: curso.id, label: curso.nome });
				}
			}
		}
	}, [showModalAddAula, idModuloProp, idCursoState, dataCursos, dataModulos, moduloAtual, setValue_A, setIdCurso]);

	const handleTipoConteudoChange = (nextUrlExterna) => {
		setUrlExterna(nextUrlExterna);
		if (clearErrors_A) {
			clearErrors_A(['file_0', 'file_1', 'file_2', 'html_externo']);
		}
		if (nextUrlExterna) {
			setFile0Selected(false);
			setFile1Selected(false);
			setFile2Selected(false);
			setValue_A('file_0', undefined);
			setValue_A('file_1', undefined);
			setValue_A('file_2', undefined);
		} else {
			setValue_A('html_externo', '');
		}
	};

	const handleClose = () => {
		setShowModalAddAula(false);
		setIdCursoLocal("");
		if (setIdCurso) {
			setIdCurso("");
		}
	};

	// Função para mostrar mensagens de toast
	const showToastMessage = (header, body, variant = 'error') => {
		const type = variant === 'success' ? 'toast-success' : variant === 'danger' ? 'toast-error' : 'toast-' + variant;
		setToast({ header, body, type });
		setShowToast(true);
	};

	// Função para submeter o formulário com feedback de toast
	const handleSubmitWithToast = async (data) => {
		setIsLoading(true);
		try {
			const result = await onSubmitAddAula(data);

			if (result && result.success) {
				showToastMessage('Sucesso!', result.message || 'Aula adicionada com sucesso.', 'success');
				setTimeout(() => {
					setShowModalAddAula(false);
					setIdCursoLocal("");
					if (setIdCurso) {
						setIdCurso("");
					}
				}, 2000);
			} else if (result) {
				showToastMessage('Erro!', result.message || 'Erro ao adicionar aula.', 'danger');
			}
		} catch (error) {
			showToastMessage('Erro!', error.message || 'Ocorreu um erro inesperado.', 'danger');
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<>
			<Toast
				show={showToast}
				onClose={() => setShowToast(false)}
				delay={4000}
				autohide
				className={`position-fixed top-0 end-0 m-3 toast-icon ${toast.type || 'toast-error'}`}
				style={{ zIndex: 1060 }}
			>
				<Toast.Header>
					<strong className="me-auto">{toast.header}</strong>
				</Toast.Header>
				<Toast.Body>{toast.body}</Toast.Body>
			</Toast>

			<Modal
				size="lg"
				show={showModalAddAula}
				onHide={handleClose}
				backdrop="static"
			>
				<Modal.Header closeButton>
					<span className="fw-semibold fs-5 text-primary">Adicionar Aula</span>
				</Modal.Header>
				<form onSubmit={handleSubmit_A(handleSubmitWithToast)}>
					<Modal.Body className="bg-gray-100 p-4">
						<div className="container">
							<div className="row">
								<div className="col-md-12">
									<div className="body">
										<div className="d-flex mb-5">
											<div className="d-flex flex-column w-100">
												<div className="row">
													<div className="row">
														<div className="col-md-4">
															<div className='col-12 h-100 red-bg d-flex align-items-center justify-content-center rounded-3'>
																<i className={`bi icon-large text-white ${urlExterna ? 'bi-link-45deg' : 'bi-cloud-upload'}`}></i>
															</div>
														</div>
														<div className="col-md-8 mt-3">
															<div className="row">
																<div className="col-12 col-md-12">
																	<div className="mb-3">
																		<input
																			type="text"
																			{...register_A("titulo", { required: true })}
																			placeholder="Título da aula"
																			className="form-control border-new-light"
																		/>
																		{errors_A.titulo && <span className='text-danger fs-7'>Título é obrigatório.</span>}
																	</div>
																</div>

																<div className="col-12 col-md-12">
																	<div className="mb-3">
																		<TextareaAutosize
																			type="text"
																			{...register_A("descricao", { required: true })}
																			placeholder="Descrição da aula"
																			className="form-control border-new-light"
																		/>
																		{errors_A.descricao && <span className='text-danger fs-7'>Descriação é obrigatório.</span>}
																	</div>
																</div>
															</div>
														</div>
													</div>

													{(idCursoLocal || idModuloProp) && (
														<div className='row mt-3'>
															<div className="col-12 mb-3">
																<div className="p-3 bg-white rounded-3 border">
																	<p className="fs-7 text-muted mb-2 mb-md-3">Conteúdo da aula</p>
																	<div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-2 gap-sm-4">
																		<span className={`small ${!urlExterna ? 'fw-semibold text-dark' : 'text-muted'}`}>
																			<i className="bi bi-hdd me-1"></i>
																			Arquivo no computador
																		</span>
																		<Form.Check
																			type="switch"
																			id="aula-conteudo-externo-switch"
																			checked={urlExterna}
																			onChange={(e) => handleTipoConteudoChange(e.target.checked)}
																			className="form-check form-switch mx-sm-2"
																			aria-label="Alternar entre arquivo local e URL externa"
																		/>
																		<span className={`small ${urlExterna ? 'fw-semibold text-dark' : 'text-muted'}`}>
																			<i className="bi bi-globe2 me-1"></i>
																			URL externa
																		</span>
																	</div>
																</div>
															</div>

															{urlExterna && (
																<div className="col-12 mb-3">
																	<label htmlFor="html_externo" className="form-label fs-7">
																		Link do conteúdo <span className="text-danger">*</span>
																	</label>
																	<input
																		id="html_externo"
																		type="text"
																		autoComplete="url"
																		inputMode="url"
																		placeholder="https://… ou link do YouTube / Vimeo"
																		className="form-control border-new-light"
																		{...register_A('html_externo', {
																			validate: (value) => {
																				if (!urlExterna) return true;
																				const t = (value || '').trim();
																				if (!t) return 'Informe a URL da aula';
																				return true;
																			},
																		})}
																	/>
																	<p className="text-muted fs-8 mt-1 mb-0">
																		Usa o vídeo ou página web informada; não é necessário enviar arquivo.
																	</p>
																	{errors_A.html_externo && (
																		<span className="text-danger fs-7">{errors_A.html_externo.message}</span>
																	)}
																</div>
															)}

															{!urlExterna && (
															<>
															<div className="col-6 col-md-4">
																<div className="mb-3">
																	<div
																		className="card border-none cursor-pointer"
																		role="button"
																		tabIndex={0}
																		onClick={() => document.getElementById('file_0')?.click()}
																		onKeyDown={(e) => {
																			if (e.key === 'Enter' || e.key === ' ') {
																				e.preventDefault();
																				document.getElementById('file_0')?.click();
																			}
																		}}
																		aria-label="Selecionar arquivo da aula"
																	>
																		<p className='fs-7 fw-bold m-2'>Arquivo da aula</p>
																		<h5 className="card-header card-upload d-flex align-items-center justify-content-center ">
																			<i className="bi bi-file-earmark-fill"></i>
																		</h5>
																		<div className="card-body d-flex justify-content-center bg-light">
																			<p className="card-text fs-7 mb-0">
																				<span className={`${file0Selected ? 'text-success' : 'text-primary'}`}>
																					Fazer Upload <i className="bi bi-cloud-upload"></i>
																				</span>
																				<Controller
																					control={control_A}
																					rules={{ required: urlExterna ? false : 'Arquivo da aula é obrigatório' }}
																					name="file_0"
																					render={({ field: { onChange, onBlur, ref } }) => (
																						<input
																							id='file_0'
																							type="file"
																							style={{ display: 'none' }}
																							onBlur={onBlur}
																							ref={ref}
																							onChange={(e) => {
																								const files = e.target.files;
																								onChange(files);
																								if (files && files.length > 0) {
																									setFile0Selected(true);
																								} else {
																									setFile0Selected(false);
																								}
																							}}
																							onClick={(e) => e.stopPropagation()}
																						/>
																					)}
																				/>
																			</p>
																		</div>
																	</div>
																</div>
															</div>
															<div className="col-6 col-md-4 border-start border-primary">
																<div className="mb-3">
																	<div
																		className="card border-none cursor-pointer"
																		role="button"
																		tabIndex={0}
																		onClick={() => document.getElementById('file_1')?.click()}
																		onKeyDown={(e) => {
																			if (e.key === 'Enter' || e.key === ' ') {
																				e.preventDefault();
																				document.getElementById('file_1')?.click();
																			}
																		}}
																		aria-label="Selecionar arquivo auxiliar 1"
																	>
																		<p className='fs-7 m-2'>Arquivo Auxiliar 1</p>
																		<h5 className="card-header card-upload d-flex align-items-center justify-content-center ">
																			<i className="bi bi-file-earmark-fill"></i>
																		</h5>
																		<div className="card-body d-flex justify-content-center bg-light">
																			<p className="card-text fs-7 mb-0">
																				<span className={`${file1Selected ? 'text-success' : 'text-primary'}`}>
																					Fazer Upload <i className="bi bi-cloud-upload"></i>
																				</span>
																				<Controller
																					control={control_A}
																					name="file_1"
																					render={({ field: { onChange, onBlur, ref } }) => (
																						<input
																							id='file_1'
																							type="file"
																							style={{ display: 'none' }}
																							onBlur={onBlur}
																							ref={ref}
																							onChange={(e) => {
																								const files = e.target.files;
																								onChange(files);
																								if (files && files.length > 0) {
																									setFile1Selected(true);
																								} else {
																									setFile1Selected(false);
																								}
																							}}
																							onClick={(e) => e.stopPropagation()}
																						/>
																					)}
																				/>
																			</p>
																		</div>
																	</div>
																</div>
															</div>
															<div className="col-12 col-md-4">
																<div className="mb-3">
																	<div
																		className="card border-none cursor-pointer"
																		role="button"
																		tabIndex={0}
																		onClick={() => document.getElementById('file_2')?.click()}
																		onKeyDown={(e) => {
																			if (e.key === 'Enter' || e.key === ' ') {
																				e.preventDefault();
																				document.getElementById('file_2')?.click();
																			}
																		}}
																		aria-label="Selecionar arquivo auxiliar 2"
																	>
																		<p className='fs-7 m-2'>Arquivo Auxiliar 2</p>
																		<h5 className="card-header card-upload d-flex align-items-center justify-content-center ">
																			<i className="bi bi-file-earmark-fill"></i>
																		</h5>
																		<div className="card-body d-flex justify-content-center bg-light">
																			<p className="card-text fs-7 mb-0">
																				<span className={`${file2Selected ? 'text-success' : 'text-primary'}`}>
																					Fazer Upload <i className="bi bi-cloud-upload"></i>
																				</span>
																				<Controller
																					control={control_A}
																					name="file_2"
																					render={({ field: { onChange, onBlur, ref } }) => (
																						<input
																							id='file_2'
																							type="file"
																							style={{ display: 'none' }}
																							onBlur={onBlur}
																							ref={ref}
																							onChange={(e) => {
																								const files = e.target.files;
																								onChange(files);
																								if (files && files.length > 0) {
																									setFile2Selected(true);
																								} else {
																									setFile2Selected(false);
																								}
																							}}
																							onClick={(e) => e.stopPropagation()}
																						/>
																					)}
																				/>
																			</p>
																		</div>
																	</div>
																</div>
															</div>
															{errors_A.file_0 && (
																<span className='text-danger fs-7 d-block col-12'>
																	{typeof errors_A.file_0.message === 'string'
																		? errors_A.file_0.message
																		: 'Arquivo da aula é obrigatório.'}
																</span>
															)}
															</>
															)}
														</div>
													)}
												</div>
												{!urlExterna && (
												<div className="progress col-12 mt-4">
													<div
														className="progress-bar"
														role="progressbar"
														style={{ width: `${uploadAulaProgress}` }}
														aria-valuenow={uploadAulaProgress}
														aria-valuemin="0"
														aria-valuemax="100"
													>
														{uploadAulaProgress}
													</div>
												</div>
												)}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer className="justify-content-end">
						<div className="d-flex justify-content-end">
							<button
								type="button"
								className="btn me-2"
								onClick={handleClose}
								disabled={isLoading}
							>
								Cancelar
							</button>
							<button type="submit" className="btn btn-primary" disabled={isLoading}>
								{isLoading ? (
									<>
										<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
										Salvando...
									</>
								) : (
									'Salvar'
								)}
							</button>
						</div>
					</Modal.Footer>
				</form>
			</Modal>
		</>
	);
};

export default AddAulaModal; 